import React from 'react'
import { Card, Button } from 'antd';
import styles from './course.module.css'

export const CoursesCard = ({src,title,desc}) => {
    const { Meta } = Card;
    return (
        <div>
            <Card
                hoverable
                style={{ width: 320 }}
                cover={<img alt="example" src={src} />}
                className={styles.courses_card}
                >
                <Meta title={title} description={desc}  style={{}}/>
                <Button className={styles.course_card_button}>Learn More</Button>
            </Card>
        </div>
    )
}